/**
 * SWR global config con persister localStorage.
 *
 * - La cache SWR viene idratata al mount da localStorage → apertura pagina istantanea
 * - Ogni volta che SWR aggiorna la cache in memoria, la persiste su localStorage
 * - Alla chiusura/riapertura del tab la cache è sempre disponibile
 * - `revalidateOnFocus` e `revalidateOnReconnect` sono ON → i dati si aggiornano
 *   silenziosamente in background quando l'utente torna sul tab
 */
import axios from "axios";

const STORAGE_KEY = "swr_cache_v2";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const swrFetcher = (url) =>
  axios.get(url.startsWith("http") ? url : `${API}${url}`, { withCredentials: true }).then((r) => r.data);

/** Provider persistente: legge localStorage al mount e riscrive ad ogni update */
export function localStorageProvider() {
  let map;
  try {
    const raw = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
    map = new Map(raw ? JSON.parse(raw) : []);
  } catch {
    map = new Map();
  }

  // Persistiamo (throttled) su ogni beforeunload E ogni 3s se dirty.
  const persist = () => {
    try {
      if (typeof window === "undefined") return;
      const appCache = Array.from(map.entries()).filter(([k]) => typeof k === "string" && k.startsWith("/"));
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(appCache));
    } catch {
      // quota exceeded: pulisci e riprova
      try {
        window.localStorage.removeItem(STORAGE_KEY);
      } catch { /* noop */ }
    }
  };

  if (typeof window !== "undefined") {
    window.addEventListener("beforeunload", persist);
    // Salvataggio periodico ogni 3 secondi
    setInterval(persist, 3000);
  }

  return map;
}

export const swrDefaultConfig = {
  fetcher: swrFetcher,
  revalidateOnFocus: true,
  revalidateOnReconnect: true,
  // dedupingInterval: entro 60s duplichiamo la stessa richiesta usando il valore in cache
  dedupingInterval: 60_000,
  // stale-while-revalidate implicito: SWR mostra stale + revalida in background
  keepPreviousData: true,
};

export function clearSwrPersistedCache() {
  try {
    if (typeof window !== "undefined") window.localStorage.removeItem(STORAGE_KEY);
  } catch { /* noop */ }
}
